<template>
  <div id="error-page">
    <header id="header">
      <span class="flex-item-logo">
        <router-link class="logo" to="/">
          <img class="logo-img" src="@/assets/img/logo.png" />
        </router-link>
      </span>
    </header>
    <div class="body">
      <div class="box">
        <div class="text">
          <h2>{{ $t("notFoundPage.title") }}</h2>
          <span>{{ $t("notFoundPage.subtitle") }}</span>
        </div>
        <div class="image">
          <img src="@/assets/img/static/sorry.png" alt="sorry" />
        </div>
        <router-link to="/">
          <button>{{ $t("notFoundPage.backToTop") }}</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
});
</script>

<style lang="scss" scoped>
$header-border: 3px;

#header {
  display: flex;
  position: sticky;
  align-items: center;
  background-color: var(--color-surface-subtle);
  border-bottom: var(--color-border) $header-border solid;
  height: $header-height;
  line-height: 1rem;
  box-sizing: border-box;
  left: 0;
  right: 0;
  top: 0;
  padding: 30px 15px;
  z-index: 20;

  .flex-item-logo {
    flex-grow: 1;

    .logo {
      text-align: center;
      display: block;
      padding: 15px;

      .logo-img {
        height: 42px;

        @include mq(sp) {
          height: 30px;
        }
      }
    }
  }
}

#error-page {
  height: 100vh;
  width: 100vw;

  .body {
    box-sizing: border-box;
    height: calc(100vh - #{$header-height});
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-normal);
    background-color: var(--color-background-normal);

    .box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: var(--color-surface-subtle);
      border-radius: var(--radius-lg);
      padding: 50px 100px;

      @include mq(sp) {
        max-width: calc(100vw * 0.8);
        padding: 30px 15px;
      }

      .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h2 {
          margin: 0;
          color: var(--color-text-normal);

          @include mq(sp) {
            font-size: var(--font-size-lg);
          }
        }

        span {
          font-size: var(--font-size-lg);
          color: var(--color-text-low);
        }
      }

      .image {
        margin: 30px;

        img {
          width: 400px;

          @include mq(sp) {
            width: calc(100vw * 0.8);
          }
        }
      }

      button {
        padding: 15px 30px;
        border-radius: var(--radius-rounded);
        border: none;
        background-color: var(--color-primary);
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-bold);
        color: var(--color-text-on-fixed-bg);
        cursor: pointer;
      }
    }
  }
}
</style>
